import { SvgIcon, SvgIconProps } from '@mui/material'

/* eslint-disable max-len */
export const BoardingIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} data-testid="BoardingIcon">
      <path d="M4.87427 11.659L11.9999 6.72307L19.1255 11.659V9.91794L11.9999 5L4.87427 9.88205V11.659Z" />
      <path d="M17.8854 12.1966V18.9991H14.4752V14.9786C14.4752 13.6145 13.3803 12.5017 11.9983 12.5017C10.6162 12.5017 9.53928 13.5966 9.53928 14.9786V18.9991H6.11108V12.1966L11.9983 8.06836L17.8854 12.1966Z" />
    </SvgIcon>
  )
}
